import React, { useCallback, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import useExternalOfferShoppingCart from '../../../../hooks/useExternalOfferShoppingCart';
import useSubmitOfferCartOperation from '../../../../hooks/useSubmitOfferCartOperation';
import StepTypography from '../../../typography/StepTypography';
import ShoppingCartStepperNavigation from '../../ShoppingCartStepperNavigation';
import ShoppingCartSummaryActionButton from '../../ShoppingCartSummary/ShoppingCartSummaryActionButton';
import ErrorBox from '../../../boxes/ErrorBox';

const ExternalCessionInstructionsStep = ({ prevStep, nextStep, requireBankAccount }) => {
  const { paragraphs, loading } = useExternalOfferShoppingCart();
  const { submitOperation } = useSubmitOfferCartOperation({
    certificatePassword: '',
    isExternal: true,
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleContinueOrConfirm = useCallback(() => {
    if (requireBankAccount) {
      nextStep();
      return;
    }
    setSubmitError('');
    setSubmitting(true);
    submitOperation({
      onCompleted: () => {
        setSubmitting(false);
        nextStep();
      },
      onError: (errorMessage) => {
        setSubmitting(false);
        setSubmitError(errorMessage);
      },
    });
  }, [nextStep, requireBankAccount, submitOperation]);

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height={100} />;
  }

  return (
    <Stack
      flexGrow={1}
      spacing={2}
      sx={{
        paddingX: { xs: 5, md: 5 },
      }}
    >
      {paragraphs.map(({ id, title, content }) => (
        <Stack key={id} spacing={1}>
          <StepTypography stepNumber={id} variant="small_3" fontWeight={500}>
            {title}
          </StepTypography>
          {content}
        </Stack>
      ))}
      {submitError && (
        <ErrorBox>{submitError}</ErrorBox>
      )}
      <Stack paddingTop={1}>
        <ShoppingCartStepperNavigation onBack={prevStep}>
          <ShoppingCartSummaryActionButton
            id="continue-external-cession-instructions-button"
            label={(
              <Typography variant="small_3" color="white" fontWeight={600}>
                {requireBankAccount ? 'Continuar' : 'Confirmar'}
              </Typography>
              )}
            onClick={handleContinueOrConfirm}
            loading={submitting}
            disabled={submitting}
            size="small"
          />
        </ShoppingCartStepperNavigation>
      </Stack>
    </Stack>
  );
};

ExternalCessionInstructionsStep.propTypes = {
  prevStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  requireBankAccount: PropTypes.bool,
};

ExternalCessionInstructionsStep.defaultProps = {
  requireBankAccount: true,
};

export default ExternalCessionInstructionsStep;
